import { allModelsSelector } from 'common-src/utils/selectorUtils';

export const getPatientAllergies = (state, patientId) =>
  allModelsSelector(state, 'PatientAllergy', (allergy) => allergy.patientId === patientId);
